<template>
  <div>
    <div>
      <h1 class="text-center mb-0">Terms and Conditions</h1>
      <div>
        <List />
      </div>
    </div>
  </div>
</template>

<script>
import List from "./ListTermsAndConditions.vue";

export default {
  components: {
    List,
  },
};
</script>
